import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { countries, devConfig } from 'config/config'; // Importing countries and devConfig from configuration
import { buildDocumentFileName, downloadDataUri, getDocumentFile, getDocumentFileError, getNextVersion, registerDocumentDownload, showDocumentFile } from 'helpers/registeredDocumentFile'; // Shared document file helpers

/**
 * Class representing the view for registered documents table.
 * @extends JetView
 */
export default class tableRegisteredDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: _('Acciones'), // Column header
                                    width: 140, // Column width
                                    height: 25, // Column height
                                    tooltip: false, // Each icon has its own webix_tooltip; a column tooltip would cover them all
                                    template: function (obj) {
                                        // Icons for edit, details, view file and download file; each restricted one depends on its permission
                                        let html = '';
                                        if (devConfig.getPermAction('registeredDocumentEdit', 'Edit')) {
                                            html +=
                                                "<span webix_tooltip='" +
                                                _('Editar') +
                                                "' class='webix_icon wxi-close edit prm-registeredDocumentEdit'></span>";
                                        }
                                        html +=
                                            "<span webix_tooltip='" +
                                            _('Detalles') +
                                            "' class='webix_icon wxi-close details'></span>";
                                        if (devConfig.getPermAction('registeredDocumentView', 'Add')) {
                                            html +=
                                                "<span webix_tooltip='" +
                                                _('Visualizar archivo') +
                                                "' class='webix_icon wxi-file icon-file-text viewDocumentFile prm-registeredDocumentView' style='cursor:pointer;'></span>";
                                        }
                                        if (devConfig.getPermAction('registeredDocumentDownload', 'Add')) {
                                            html +=
                                                "<span webix_tooltip='" +
                                                _('Descargar') +
                                                "' class='webix_icon wxi-download downloadDocumentFile prm-registeredDocumentDownload' style='cursor:pointer;'></span>";
                                        }
                                        return html;
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre del documento'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Route', // Column ID
                                    header: _('Ruta'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'EncryptionValue', // Column ID
                                    header: _('Encriptación'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('Id Externo'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo de documento'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'LoadingDate', // Column ID for upload date (Y-m-d H:i:s)
                                    header: _('Fecha de carga'), // Localized column header
                                    width: 170, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'ProfilesCount', // Column ID for authorized profiles count
                                    header: _('Cantidad de perfiles autorizados'), // Localized column header
                                    width: 230, // Column width
                                    sort: 'int', // Sorting type
                                    css: { 'text-align': 'right' },
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    options: [
                                        // Options for the column
                                        { id: 'A', value: _('Activo') }, // Active option
                                        { id: 'I', value: _('Inactivo') }, // Inactive option
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaisId', // Column ID
                                    header: _('Pais'), // Localized column header
                                    options: countries, // Options for the column
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    // Version, EncryptionValue and EncryptionMethod are used by Añadir Versión to build the next version
                                    this.$scope.app.callEvent('version:id', [
                                        item.Id,
                                        item.Name,
                                        item.Version,
                                        item.EncryptionValue,
                                        item.EncryptionMethod,
                                    ]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Check screen size
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                                edit: function (euv, id) {
                                    // Handler for edit icon click: the form is filled from GetDocumentById
                                    vthis.app.callEvent('openEdit', [this.getItem(id.row)]); // Trigger edit event with the clicked row
                                },
                                viewDocumentFile: function (e, id) {
                                    // Handler for view file icon click: shared "Visualizar archivo" window
                                    showDocumentFile(this.getItem(id.row), _, devConfig.getPermAction('registeredDocumentDownload', 'Add'), true); // Id and Version from the GetDocuments row, with download audit
                                },
                                downloadDocumentFile: function (e, id) {
                                    // Handler for download icon click: same resource as view file, without preview
                                    const item = this.getItem(id.row); // Getting the clicked row item
                                    getDocumentFile(
                                        item,
                                        function (url, extension) {
                                            if (downloadDataUri(url, buildDocumentFileName(item.Name, extension))) {
                                                registerDocumentDownload(item, extension); // Audit only when the download was triggered
                                            }
                                        },
                                        function () {
                                            // Request error, backend error or empty file
                                            webix.message(_('No se pudo obtener el archivo'));
                                        },
                                    );
                                },
                            },
                            on: {
                                // Evaluated on every load (filter, reload, sort), not only the first one
                                onAfterLoad: function () {
                                    if (this.count()) {
                                        this.hideOverlay(); // Data received: remove a previous "No hay datos"
                                    } else {
                                        this.showOverlay(
                                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                                _('No hay datos') +
                                                '</div>',
                                        ); // Show no data overlay
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
            on: {
                // Global event handlers
                onItemDblClick: (id) => {
                    // Handler for double-click on an item, same permission as the edit icon
                    if (!devConfig.getPermAction('registeredDocumentEdit', 'Edit')) {
                        return;
                    }
                    this.app.callEvent('openEdit', [$$('datatable').getItem(id)]); // Same flow as the edit icon
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetDocuments'; // API URL for fetching documents
        var filter = ''; // Filter string
        const app = this.app; // Used to notify the versions table after AddVersion
        // Adjusts total_count when fewer rows than the page size arrive (last block),
        // avoiding extra GetDocuments requests that render repeated records.
        grid.data.attachEvent('onParse', function (driver, response) {
            if (!response || !webix.isArray(response.data)) {
                return;
            }
            var pos = parseInt(response.pos, 10) || 0;
            var received = response.data.length;
            if (received < grid.data.$pagesize || (parseInt(response.total_count, 10) || 0) < pos + received) {
                response.total_count = pos + received;
            }
        });
        this.on(this.app, 'registeredDocument:filter', (filterData) => {
            // Event listener for filtering documents
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });
        var datePopup = []; // Array for date popup options
        var datePopup2 = []; // Array for second date popup options
        var popupAdd = ''; // Variable for add document popup
        var editFileBase64 = ''; // Base64 content (data URI) of the replacement file in edit popup
        var editCurrentFile = ''; // Data URI of the stored file (GetDocumentFile) loaded when the edit popup opens
        var editFileRequest = 0; // Increments per load so a late response from a previous document is ignored
        var editFileKey = ''; // Id|Version of the document whose stored file is loaded in the edit popup
        var editSaving = false; // True while UpdateDocument (or its file lookup) is in progress

        // Reloads the datatable keeping the filters of the last query
        function reloadGrid() {
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
        }
        this.on(this.app, 'registeredDocument:reload', reloadGrid); // Version added from the versions panel (record.js)

        // Normalizes Profiles to an array, as UpdateDocument expects
        function toProfileArray(profile) {
            if (webix.isArray(profile)) {
                return profile;
            }
            return profile ? String(profile).split(',') : [];
        }

        // Clears the replacement file selected in the edit popup
        function resetEditFile() {
            editFileBase64 = '';
            $$('EditFile').files.clearAll();
            $$('EditFileNameLabel').setHTML('');
            updateEditSaveState();
        }

        // Only Name, IsActivate and File are editable; compares them with the values loaded from GetDocumentById
        function hasEditChanges() {
            var values = $$('editForm').getValues();
            var original = $$('editForm').getCleanValues();
            return (
                String(values.Name || '').trim() !== String(original.Name || '').trim() ||
                String(values.IsActivate || '') !== String(original.IsActivate || '') ||
                !!editFileBase64
            );
        }

        // Save is enabled only when there are changes and no UpdateDocument is in progress
        function updateEditSaveState() {
            var saveButton = $$('EditSaveButton');
            if (!saveButton) {
                return;
            }
            if (!editSaving && hasEditChanges()) {
                saveButton.enable();
            } else {
                saveButton.disable();
            }
        }

        // Loads the stored file of the loaded document and shows its name, same flow as "Visualizar archivo"
        function loadEditCurrentFile() {
            var values = $$('editForm').getValues();
            var key = values.Id + '|' + values.Version;
            if (!values.Id || key === editFileKey) {
                return; // No document loaded yet, or already loaded/loading
            }
            editFileKey = key;
            var request = ++editFileRequest;
            editCurrentFile = '';
            $$('EditCurrentFileLabel').setHTML(_('Cargando...'));
            getDocumentFile(
                values,
                function (url, extension) {
                    if (request !== editFileRequest) {
                        return;
                    }
                    editCurrentFile = url;
                    $$('EditCurrentFileLabel').setHTML(
                        _('Archivo actual: ') + webix.template.escape(buildDocumentFileName(values.Name, extension)),
                    );
                },
                function () {
                    if (request !== editFileRequest) {
                        return;
                    }
                    $$('EditCurrentFileLabel').setHTML(_('No se pudo obtener el archivo'));
                },
            );
        }

        var popup = webix.ui({
            // Create edit document popup
            view: 'window',
            id: 'EditDocument', // ID for the popup
            width: 450, // Width of the popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Editar Documento') }, // Label for the popup
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Click handler for close icon
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            on: {
                onBeforeShow: function () {
                    // Fits small screens; the form scrolls when its content is taller
                    this.define('height', Math.min(760, window.innerHeight - 40));
                    this.resize();
                },
                onShow: function () {
                    // Deferred so the form values set by openEdit are already rendered
                    webix.delay(loadEditCurrentFile);
                },
                onHide: function () {
                    resetEditFile(); // Discard the replacement file whenever the popup closes
                    editFileRequest++; // Ignore any pending GetDocumentFile response
                    editFileKey = '';
                    editCurrentFile = '';
                    $$('EditCurrentFileLabel').setHTML('');
                },
            },
            body: {
                view: 'form', // Form inside the popup
                id: 'editForm', // ID for the form
                scroll: 'y', // Enable vertical scrolling
                on: {
                    // Renders the document's Profiles each time the form receives values
                    onValues: function () {
                        var profiles = toProfileArray(this.getValues().Profiles);
                        $$('EditProfilesList').setHTML(
                            profiles.length
                                ? // Capped height with scroll so long lists don't push the buttons out of view
                                  "<div style='max-height:110px;overflow-y:auto;'>" +
                                      profiles
                                          .map(function (profile) {
                                              return '<div>' + webix.template.escape(profile) + '</div>';
                                          })
                                          .join('') +
                                      '</div>'
                                : '-',
                        );
                        if ($$('EditDocument') && $$('EditDocument').isVisible()) {
                            loadEditCurrentFile(); // Values set while the popup is open
                        }
                        updateEditSaveState(); // New document loaded: nothing changed yet
                    },
                },
                elements: [
                    {
                        view: 'text', // Text input for ID
                        label: 'ID',
                        name: 'Id',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Text input for Name
                        label: _('Nombre'),
                        name: 'Name',
                        labelWidth: 140, // Label width
                        on: {
                            onTimedKeyPress: updateEditSaveState, // While typing, onChange only fires on blur
                            onChange: updateEditSaveState,
                        },
                    },
                    {
                        view: 'text', // Text input for Route
                        label: _('Ruta'),
                        name: 'Route',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Text input for Version
                        label: _('Versión'),
                        name: 'Version',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Text input for EncryptionValue
                        label: _('Encriptación'),
                        name: 'EncryptionValue',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Text input for ExternalId
                        label: _('Id Externo'),
                        name: 'ExternalId',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Type name as returned by GetDocumentById; its id is resolved on save
                        label: _('Tipo Documento'),
                        name: 'Type',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        cols: [
                            { view: 'label', label: _('Perfil'), width: 140 }, // Label for Profiles
                            {
                                view: 'template', // Read-only list of assigned profiles, filled on onValues
                                id: 'EditProfilesList',
                                borderless: true,
                                autoheight: true,
                                template: '',
                            },
                        ],
                    },
                    {
                        view: 'text', // Text input for Access
                        label: _('Tipo de Acceso'),
                        name: 'Access',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'text', // Text input for LoadingDate
                        label: _('Fecha de carga'),
                        name: 'LoadingDate',
                        readonly: true, // Read-only field
                        labelWidth: 140, // Label width
                    },
                    {
                        view: 'combo', // Combo box for IsActivate
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            // Options for the combo box
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Deactivated option
                        ],
                        labelWidth: 140, // Label width
                        // Without permission the field is hidden and the current status is sent unchanged
                        hidden: !devConfig.getPermAction('registeredDocumentInactivate', 'Edit'),
                        css: 'prm-registeredDocumentInactivate',
                        on: {
                            onChange: updateEditSaveState,
                        },
                    },
                    {
                        view: 'template', // Name of the stored file, filled by loadEditCurrentFile
                        id: 'EditCurrentFileLabel',
                        hidden: !devConfig.getPermAction('registeredDocumentReplaceFile', 'Edit'), // Part of the replace file permission
                        borderless: true,
                        autoheight: true,
                        template: '',
                    },
                    {
                        view: 'uploader', // Optional file picker to replace the document
                        id: 'EditFile',
                        value: _('Cargar Archivo'),
                        multiple: false,
                        autosend: false,
                        accept: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
                        label: _('Archivo'),
                        labelWidth: 140, // Label width
                        // Without permission the picker is hidden and the current file is sent unchanged
                        hidden: !devConfig.getPermAction('registeredDocumentReplaceFile', 'Edit'),
                        css: 'prm-registeredDocumentReplaceFile',
                        on: {
                            // Validates extension and size before adding the file;
                            // on error, clears the current selection and cancels the add.
                            onBeforeFileAdd: function (uploadedFile) {
                                var errorText = getDocumentFileError(uploadedFile, _);
                                if (errorText) {
                                    resetEditFile();
                                    webix.message({
                                        title: _('¡Error!'),
                                        type: 'alert-error',
                                        text: errorText,
                                    });
                                    return false;
                                }
                                return true;
                            },
                            onAfterFileAdd: function (uploadedFile) {
                                editFileBase64 = '';
                                $$('EditFileNameLabel').setHTML('');
                                var reader = new FileReader();
                                reader.onload = function () {
                                    // Skip if the file was replaced before the read finished
                                    if (!$$('EditFile').files.exists(uploadedFile.id)) {
                                        return;
                                    }
                                    editFileBase64 = reader.result;
                                    $$('EditFileNameLabel').setHTML(_('Archivo seleccionado: ') + uploadedFile.name);
                                    updateEditSaveState();
                                };
                                reader.readAsDataURL(uploadedFile.file);
                            },
                        },
                    },
                    {
                        view: 'template', // Shows the name of the replacement file
                        id: 'EditFileNameLabel',
                        hidden: !devConfig.getPermAction('registeredDocumentReplaceFile', 'Edit'), // Same permission as the picker
                        borderless: true,
                        autoheight: true,
                        template: '',
                    },
                    {
                        cols: [
                            // Buttons for Cancel and Save
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    // Click handler for cancel button
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('editForm').setValues($$('editForm').getCleanValues()); // Reset form values
                                },
                            },
                            {
                                view: 'button',
                                id: 'EditSaveButton',
                                type: 'form', // Button type
                                value: _('Guardar'), // Save button
                                disabled: true, // Enabled by updateEditSaveState when something changes
                                click: function ($e) {
                                    // Click handler for save button
                                    var saveButton = this;
                                    var values = $$('editForm').getValues(); // Get form values
                                    var name = String(values.Name || '').trim();

                                    if (!hasEditChanges()) {
                                        return; // Safety net, the button is disabled without changes
                                    }
                                    if (!name) {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'),
                                        });
                                        return;
                                    }

                                    // Re-enables Save after a failed attempt, keeping the entered data
                                    function endSaving() {
                                        editSaving = false;
                                        updateEditSaveState();
                                    }

                                    // Closes the popup after the whole save finished
                                    function finishSave() {
                                        editSaving = false;
                                        webix.message(successMessage); // Message matching the performed action
                                        reloadGrid(); // Reload the datatable with the current filters
                                        $$('editForm').setValues($$('editForm').getCleanValues()); // Reset form values
                                        saveButton.getTopParentView().hide(); // Hide the popup only after a successful save
                                    }

                                    // Sends the replacement file as a new version, so users must accept it again
                                    function sendVersion() {
                                        var payload = {
                                            Id: values.Id,
                                            Version: nextVersion,
                                            EncryptionMethod: values.EncryptionMethod, // From GetDocumentById, same as Añadir Versión
                                            EncryptionValue: values.EncryptionValue, // Unchanged
                                            File: editFileBase64,
                                        };
                                        webix
                                            .ajax() // AJAX request to add the new version
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'RegisteredDocument/AddVersion',
                                                JSON.stringify(payload), // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handler: popup stays open with the selected file
                                                        endSaving();
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (resp.HasError) {
                                                            endSaving();
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                            });
                                                        } else {
                                                            app.callEvent('registeredDocument:versionAdded', [values.Id, nextVersion]); // Refreshes the versions panel if it shows this document
                                                            finishSave();
                                                        }
                                                    },
                                                },
                                            );
                                    }

                                    // Sends UpdateDocument with the given file (data URI, same format as AddDocument)
                                    function sendUpdate(file, onSuccess) {
                                        var payload = {
                                            Id: values.Id,
                                            Name: name,
                                            Route: values.Route,
                                            Version: values.Version,
                                            Type: values.TypeId, // Type id from GetDocumentById, same as AddDocument
                                            Profile: toProfileArray(values.Profiles),
                                            IsActivate: values.IsActivate,
                                            EncryptionMethod: 'SHA-1',
                                            EncryptionValue: values.EncryptionValue,
                                            ExternalId: values.ExternalId,
                                            File: file,
                                            Access: values.Access,
                                            LoadingDate: values.LoadingDate,
                                        };
                                        webix
                                            .ajax() // AJAX request to update document
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'RegisteredDocument/UpdateDocument',
                                                JSON.stringify(payload), // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handler: popup stays open with the entered data
                                                        endSaving();
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success handler
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (resp.HasError) {
                                                            // Check for errors, popup stays open with the entered data
                                                            endSaving();
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                            });
                                                        } else {
                                                            onSuccess();
                                                        }
                                                    },
                                                },
                                            );
                                    }

                                    // UpdateDocument saved name/status: they become the clean values, so a retry after
                                    // a failed AddVersion only sends the new version
                                    function afterUpdateWithVersion() {
                                        var saved = webix.copy(values);
                                        saved.Name = name;
                                        $$('editForm').setValues(saved);
                                        reloadGrid();
                                        sendVersion();
                                    }

                                    function startUpdate() {
                                        editSaving = true;
                                        saveButton.disable(); // Prevents a second submit while saving
                                        if (fileChanged && !nameChanged && !statusChanged) {
                                            sendVersion(); // Only the file replaced
                                            return;
                                        }
                                        var onUpdated = fileChanged ? afterUpdateWithVersion : finishSave;
                                        // UpdateDocument keeps the current file; a new one goes in AddVersion
                                        if (editCurrentFile) {
                                            sendUpdate(editCurrentFile, onUpdated);
                                            return;
                                        }
                                        // Stored file not loaded yet (or failed on open): retrieve it again
                                        getDocumentFile(
                                            { Id: values.Id, Version: values.Version },
                                            function (url) {
                                                sendUpdate(url, onUpdated);
                                            },
                                            function () {
                                                endSaving();
                                                webix.message(_('No se pudo obtener el archivo'));
                                            },
                                        );
                                    }

                                    // Inactivating a document requires confirmation; other changes are sent directly
                                    var inactivating =
                                        values.IsActivate === 'I' && $$('editForm').getCleanValues().IsActivate !== 'I';
                                    // Specific message only when a single field changed; several changes use the general one
                                    var clean = $$('editForm').getCleanValues();
                                    var nameChanged = name !== String(clean.Name || '').trim();
                                    var statusChanged = String(values.IsActivate || '') !== String(clean.IsActivate || '');
                                    var fileChanged = !!editFileBase64;
                                    // Replacing the file always creates a new version (AddVersion), whatever the Access
                                    var nextVersion = fileChanged ? getNextVersion(values.Version) : '';
                                    if (fileChanged && !nextVersion) {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Ocurrio un error, comuniquese con soporte'),
                                        });
                                        return;
                                    }
                                    var changesCount = [nameChanged, statusChanged, fileChanged].filter(Boolean).length;
                                    var successMessage = _('Documento actualizado correctamente.');
                                    if (changesCount === 1 && fileChanged) {
                                        successMessage = _('Archivo reemplazado correctamente.');
                                    } else if (changesCount === 1 && inactivating) {
                                        successMessage = _('Documento inactivado correctamente.');
                                    }
                                    if (!inactivating) {
                                        startUpdate();
                                        return;
                                    }
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('¿Desea inactivar el documento?'), // Confirmation text
                                        ok: _('Aceptar'), // Confirm button text
                                        cancel: _('Cancelar'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                startUpdate();
                                            }
                                        },
                                    });
                                },
                            },
                        ],
                    },
                ],
            },
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for after sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'addDocument:button', (filter) => {
            // Event listener for adding documents
            webix
                .ajax() // AJAX request to get document types
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(devConfig.geturlApi() + 'RegisteredDocument/TypeDocument', '', {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handler
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handler
                        var resp = JSON.parse(text); // Parse response
                        if (!resp.HasError) {
                            // Check for errors
                            datePopup = resp.Data; // Store document types
                        }
                        webix
                            .ajax() // AJAX request to get profiles
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(devConfig.geturlApi() + 'Select/GetProfile', '', {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handler
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handler
                                    var resp = JSON.parse(text); // Parse response
                                    if (!resp.HasError) {
                                        // Check for errors
                                        datePopup2 = resp.Data; // Store profiles
                                    }
                                    buildAddDocumentPopup();
                                },
                            });
                    },
                });
        });

        function buildAddDocumentPopup() {
            var fileBase64 = ''; // Base64 content (data URI) of the selected file
            var providerData = null; // Cache for RegisteredDocument/GetDocumentProvider, fetched only once per popup session

            // Renders the "Id Externo" row (text field + search button) using an already-fetched provider list
            function renderExternalIdRow(providerList) {
                if ($$('r6')) {
                    $$('r5').removeView('r6'); // Avoid stacking duplicate rows
                }
                $$('r5').addView({
                    id: 'r6',
                    rows: [
                        {
                            cols: [
                                {
                                    view: 'text', // Text input for ExternalId
                                    label: _('Id Externo'),
                                    name: 'ExternalId',
                                    labelWidth: 140, // Label width
                                    disabled: true, // Disabled field
                                    id: 'selectExternalId', // ID for the input
                                },
                                {
                                    width: 30, // Width for the button
                                    css: 'back-button', // CSS class for styling
                                    view: 'button', // Button for searching external ID
                                    type: 'icon',
                                    icon: 'icon-magnifying-glass',
                                    align: 'center',
                                    click: () => {
                                        // Click handler for search button
                                        webix
                                            .ui({
                                                view: 'window', // Create search window
                                                head: {
                                                    view: 'toolbar', // Toolbar for the window header
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: _('Id Externo'), // Label for the window
                                                            align: 'center',
                                                        },
                                                        {
                                                            view: 'icon', // Close icon
                                                            icon: 'wxi-close',
                                                            click: function () {
                                                                // Click handler for close icon
                                                                this.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    ],
                                                },
                                                id: 'searchExternalId', // ID for the search window
                                                modal: true, // Modal window
                                                position: 'center', // Center position for the window
                                                width: 500, // Width of the window
                                                height: 425, // Height of the window
                                                body: {
                                                    rows: [
                                                        {
                                                            view: 'datatable', // DataTable for displaying external IDs
                                                            select: true, // Enable row selection
                                                            columns: [
                                                                {
                                                                    id: 'id', // Column ID
                                                                    header: ['Id', { content: 'textFilter' }], // Text filter for the column
                                                                    width: 250, // Column width
                                                                },
                                                                {
                                                                    id: 'value', // Column ID
                                                                    header: [_('Nombre'), { content: 'textFilter' }], // Localized column header
                                                                    fillspace: true, // Fill space for the column
                                                                },
                                                            ],
                                                            data: providerList, // Data for the datatable
                                                            on: {
                                                                onItemDblClick: function (id) {
                                                                    // Handler for double-click on item
                                                                    var item = this.getItem(id); // Get the clicked item
                                                                    $$('selectExternalId').setValue(item.id); // Set external ID value
                                                                    $$('Name').setValue(item.value); // Set name value
                                                                    $$('Name').define('disabled', true); // Disable name input
                                                                    $$('searchExternalId').hide(); // Hide search window
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                            })
                                            .show(); // Show search window
                                    },
                                },
                            ],
                        },
                    ],
                });
            }

            popupAdd = webix.ui({
                                        // Create add document popup
                                        view: 'window',
                                        id: 'AddDocument', // ID for the popup
                                        width: 450, // Width of the popup
                                        head: {
                                            view: 'toolbar', // Toolbar for the popup header
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Añadir Documento'), // Label for the popup
                                                },
                                                {
                                                    view: 'icon', // Close icon
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        // Click handler for close icon
                                                        this.getTopParentView().hide(); // Hide the popup
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center position for the popup
                                        modal: true, // Modal popup
                                        body: {
                                            view: 'form', // Form inside the popup
                                            id: 'addform', // ID for the form
                                            values: { Version: '1' }, // Initial version; getCleanValues() restores it on reset
                                            elements: [
                                                {
                                                    id: 'r5', // ID for the row
                                                    rows: [
                                                        {
                                                            view: 'text', // Text input for Name
                                                            label: _('Nombre'),
                                                            name: 'Name',
                                                            id: 'Name',
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'text', // Numeric input for Version
                                                            type: 'number',
                                                            label: _('Versión'),
                                                            name: 'Version',
                                                            value: '1', // Initial version shown when the popup opens
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                            attributes: { min: 1, step: 1, inputmode: 'decimal' }, // Spinner goes 1 by 1
                                                            on: {
                                                                // Only digits, point (never comma, the backend expects 1.5) and control keys
                                                                onKeyPress: function (code, e) {
                                                                    if (e.ctrlKey || e.metaKey) return true; // Copy/paste/select all
                                                                    if (e.key === '.') return true; // Point from keyboard or numpad
                                                                    if (e.shiftKey) return code === 9 || (code >= 35 && code <= 40);
                                                                    return (
                                                                        (code >= 48 && code <= 57) || // Digits
                                                                        (code >= 96 && code <= 105) || // Numpad digits
                                                                        code === 8 || // Backspace
                                                                        code === 9 || // Tab
                                                                        code === 13 || // Enter
                                                                        code === 46 || // Delete
                                                                        (code >= 35 && code <= 40) // Home, End, arrows
                                                                    );
                                                                },
                                                                onChange: function (value) {
                                                                    // 0 or negative (e.g. pasted) is cleared, so the required rule blocks the save
                                                                    if (value !== '' && !(parseFloat(value) > 0)) {
                                                                        this.setValue('');
                                                                    }
                                                                    this.validate(); // Keeps the elementsConfig validation, replaced by this "on"
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: 'text', // Text input for EncryptionValue
                                                            label: _('Encriptación'),
                                                            name: 'EncryptionValue',
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for Type
                                                            label: _('Tipo Documento'),
                                                            name: 'Type',
                                                            options: datePopup, // Options for the combo box
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for IsActivate
                                                            label: _('Estado'),
                                                            name: 'IsActivate',
                                                            options: [
                                                                // Options for the combo box
                                                                {
                                                                    id: 'A',
                                                                    value: _('Activado'), // Activated option
                                                                },
                                                                {
                                                                    id: 'I',
                                                                    value: _('Inactivado'), // Deactivated option
                                                                },
                                                            ],
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'multicombo', // Multi-select combo for Profile
                                                            label: _('Perfil'),
                                                            name: 'Profile',
                                                            options: datePopup2, // Options for the multicombo
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                            // Shows the selected count instead of one tag per profile, so the popup height stays fixed
                                                            tagMode: false,
                                                            tagTemplate: function (values) {
                                                                return values.length
                                                                    ? values.length + ' ' + _('perfiles seleccionados')
                                                                    : '';
                                                            },
                                                            on: {
                                                                // Clears the search text left in the input after picking a profile.
                                                                // Webix redraws this input on every refresh from its internal "ib"
                                                                // text buffer, so clearing only the DOM node isn't enough.
                                                                onChange: function () {
                                                                    this.ib = '';
                                                                    var node = this.getInputNode ? this.getInputNode() : null;
                                                                    if (node) {
                                                                        node.value = '';
                                                                    }
                                                                    if (this.refresh) {
                                                                        this.refresh();
                                                                    }
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for Access
                                                            label: _('Tipo de Acceso'),
                                                            name: 'Access',
                                                            id: 'Access',
                                                            options: [
                                                                { id: 'INFORMATIVE', value: _('Informativo') },
                                                                { id: 'APPROVAL', value: _('Aprobación') },
                                                            ],
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for TypeMethod
                                                            label: _('Tipo Método'),
                                                            name: 'TypeMethod',
                                                            options: [
                                                                // Options for the combo box
                                                                {
                                                                    id: '0',
                                                                    value: _('Propio'), // Own option
                                                                },
                                                                {
                                                                    id: '1',
                                                                    value: _('Proveedor'), // Provider option
                                                                },
                                                            ],
                                                            on: {
                                                                // Event handler for change event
                                                                onChange: function (data, obj) {
                                                                    var currentValue = this.getValue(); // Get current value
                                                                    if (currentValue == '1') {
                                                                        // Check if provider is selected
                                                                        if (providerData) {
                                                                            // Already fetched once in this popup session: reuse it, no new request
                                                                            renderExternalIdRow(providerData);
                                                                            return;
                                                                        }
                                                                        if ($$('r6')) {
                                                                            $$('r5').removeView('r6');
                                                                        }
                                                                        $$('r5').addView({
                                                                            // Temporary loading indicator while the provider list is fetched
                                                                            id: 'r6',
                                                                            rows: [
                                                                                {
                                                                                    template: _('Cargando...'),
                                                                                    borderless: true,
                                                                                    autoheight: true,
                                                                                },
                                                                            ],
                                                                        });
                                                                        webix
                                                                            .ajax() // AJAX request to get document provider
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'RegisteredDocument/GetDocumentProvider',
                                                                                '',
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Error handler
                                                                                        webix.message(_('Error! ')); // Show error message
                                                                                        if ($$('r6')) {
                                                                                            $$('r5').removeView('r6');
                                                                                        }
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Success handler
                                                                                        var response = JSON.parse(text); // Parse response
                                                                                        providerData = response.Data; // Cache for subsequent toggles
                                                                                        renderExternalIdRow(providerData);
                                                                                    },
                                                                                },
                                                                            );
                                                                    } else {
                                                                        if ($$('r6')) {
                                                                            $$('r5').removeView('r6'); // Remove external ID view
                                                                        }
                                                                        $$('Name').define('disabled', false); // Enable name input
                                                                    }
                                                                },
                                                            },
                                                            required: true, // Required field
                                                            labelWidth: 140, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for CountrySelect
                                                            name: 'CountrySelect',
                                                            id: 'CountrySelect',
                                                            localId: 'regions:combo', // Local ID for the combo
                                                            label: _('País'), // Localized label
                                                            labelWidth: 140, // Label width
                                                            required: true, // Required field
                                                            options: {
                                                                body: {
                                                                    template: function (obj) {
                                                                        // Template for displaying country options
                                                                        return (
                                                                            "<i class='flags " +
                                                                            obj.icon +
                                                                            "'></i>" +
                                                                            obj.value
                                                                        );
                                                                    },
                                                                    data: countries, // Data for the options
                                                                },
                                                            },
                                                            css: 'prm-filterByCountry', // CSS class for styling
                                                        },
                                                        {
                                                            view: 'uploader', // File picker for the document
                                                            id: 'File',
                                                            name: 'File',
                                                            value: _('Cargar Archivo'),
                                                            multiple: false,
                                                            autosend: false,
                                                            accept: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
                                                            label: _('Archivo'),
                                                            labelWidth: 140, // Label width
                                                            on: {
                                                                // Validates extension and size (max 5.000 KB) before adding the file;
                                                                // on error, clears the current selection and cancels the add.
                                                                onBeforeFileAdd: function (uploadedFile) {
                                                                    var errorText = getDocumentFileError(uploadedFile, _);
                                                                    if (errorText) {
                                                                        fileBase64 = '';
                                                                        this.files.clearAll();
                                                                        $$('FileNameLabel').setHTML('');
                                                                        webix.message({
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                            text: errorText,
                                                                        });
                                                                        return false;
                                                                    }
                                                                    return true;
                                                                },
                                                                onAfterFileAdd: function (uploadedFile) {
                                                                    fileBase64 = '';
                                                                    $$('FileNameLabel').setHTML('');
                                                                    var reader = new FileReader();
                                                                    reader.onload = function () {
                                                                        // Skip if the file was replaced before the read finished
                                                                        if (!$$('File').files.exists(uploadedFile.id)) {
                                                                            return;
                                                                        }
                                                                        fileBase64 = reader.result;
                                                                        $$('FileNameLabel').setHTML(
                                                                            _('Archivo seleccionado: ') + uploadedFile.name,
                                                                        );
                                                                    };
                                                                    reader.readAsDataURL(uploadedFile.file);
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: 'template', // Shows the name of the currently selected file
                                                            id: 'FileNameLabel',
                                                            borderless: true,
                                                            autoheight: true,
                                                            template: '',
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        // Buttons for Cancel and Save
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                // Click handler for cancel button
                                                                this.getTopParentView().hide(); // Hide the popup
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form', // Button type
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                // Click handler for save button
                                                                let values = $$('addform').getValues(); // Get form values
                                                                if (!fileBase64) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Debes adjuntar un archivo'),
                                                                    });
                                                                    return;
                                                                }
                                                                if ($$('addform').validate()) {
                                                                    // Validate form
                                                                    var saveButton = this;
                                                                    saveButton.disable(); // Prevents a second submit while AddDocument is in progress
                                                                    var payload = {
                                                                        Name: values.Name,
                                                                        Version: values.Version,
                                                                        Type: values.Type,
                                                                        IsActivate: values.IsActivate,
                                                                        EncryptionMethod: 'SHA-1',
                                                                        EncryptionValue: values.EncryptionValue,
                                                                        TypeMethod: values.TypeMethod,
                                                                        ExternalId: values.ExternalId,
                                                                        CountryId: values.CountrySelect,
                                                                        File: fileBase64,
                                                                        Profile: values.Profile ? values.Profile.split(',') : [],
                                                                        Access: values.Access,
                                                                        Partner: devConfig.getPartnerSelected(), // Partner selected in the session (toolbar)
                                                                    };
                                                                    webix
                                                                        .ajax() // AJAX request to add document
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'RegisteredDocument/AddDocument',
                                                                            JSON.stringify(payload), // JSON payload
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Error handler: popup stays open with the entered data
                                                                                    saveButton.enable();
                                                                                    webix.message('Error! '); // Show error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Success handler
                                                                                    saveButton.enable();
                                                                                    var resp = JSON.parse(text); // Parse response
                                                                                    if (resp.HasError) {
                                                                                        // Check for errors, popup stays open with the entered data
                                                                                        webix.message({
                                                                                            title: _('¡Error!'), // Error title
                                                                                            type: 'alert-error', // Error type
                                                                                            text: _(
                                                                                                'Ocurrio un error, comuniquese con soporte',
                                                                                            ), // Error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            _('Documento creado correctamente.'),
                                                                                        ); // Success message
                                                                                        reloadGrid(); // Reload the datatable with the current filters
                                                                                        $$('addform').setValues(
                                                                                            $$('addform').getCleanValues(),
                                                                                        ); // Reset form values
                                                                                        fileBase64 = ''; // Reset selected file
                                                                                        $$('FileNameLabel').setHTML('');
                                                                                        saveButton.getTopParentView().hide(); // Hide the popup only after a successful save
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                } else {
                                                                    webix.message({
                                                                        // Show validation error message
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error', // Error type
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        // Event handler for change event
                                                        this.validate(); // Validate form
                                                    },
                                                },
                                            },
                                        },
                                    });
            $$('addform').clearValidation(); // Clear validation for the form
            popupAdd.show(); // Show add document popup
        }
        var editLoadRequest = 0; // Ignores a late GetDocumentById response when another document was opened
        this.on(this.app, 'openEdit', (item) => {
            // Event listener for opening edit popup: fills the form from GetDocumentById (Id and Version of the row)
            if (!item) {
                return;
            }
            devConfig.setPrm('registeredDocumentEdit'); // Edit permission for this request, also from double click
            var request = ++editLoadRequest;
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(
                    devConfig.geturlApi() + 'RegisteredDocument/GetDocumentById',
                    JSON.stringify({ Id: item.Id, Version: item.Version }),
                    {
                        error: function () {
                            if (request === editLoadRequest) {
                                webix.message(_('No se pudo obtener el documento'));
                            }
                        },
                        success: function (text) {
                            if (request !== editLoadRequest) {
                                return;
                            }
                            var resp;
                            try {
                                resp = JSON.parse(text);
                            } catch (e) {
                                resp = null;
                            }
                            // Same structure as GetDocuments: the document comes in data (array or object)
                            var data = resp && !resp.HasError ? resp.data || resp.Data : null;
                            var documentData = webix.isArray(data) ? data[0] : data;
                            if (!documentData) {
                                webix.message(_('No se pudo obtener el documento'));
                                return;
                            }
                            $$('editForm').setValues(documentData); // Also becomes the clean values used to detect changes
                            popup.show(); // Show edit document popup
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
